import { FRONTEND_URL, BACKEND_URL } from "@/config/app";
import { useAuthStore } from "@/stores";

export default {
    install(app) {
        const auth = useAuthStore();

        app.config.globalProperties.$frontend = (path) => FRONTEND_URL + path;
        app.config.globalProperties.$backend = (path) => BACKEND_URL + path;
        console.log('Global Properties Installed Successfully ✅')

        // Create a single handler factory that returns handlers for different data sources
        const createHandler = (dataSource) => ({
            get: (target, key) => {
                return auth[dataSource] ? auth[dataSource][key] : undefined;
            }
        });
        
        app.config.globalProperties.$user = new Proxy(auth.user ? auth.user : {}, createHandler('user'));
        app.config.globalProperties.$company = new Proxy(auth.company ? auth.company : {}, createHandler('company'));

    }
}   